import { ActionTree } from 'vuex'

import {
  getQuestionnaireAnswers as fetchQuestionnaireAnswers,
  getQuestionnaireAnswer as fetchQuestionnaireAnswer,
  updateQuestionnaireAnswer,
  updateQuestionAnswer,
} from '@/api/questionnaire-answer'
import { AnswerSummary } from '@/types/questionnaire-answer'
import { QuestionnaireAnswerState, RootState } from '@/types/store'
import { getReceipt } from '@/api/receipts'
import { QuestionType } from '@/types/questionnaire'
import {
  QuestionnaireAnswerEntity,
  UpdateQuestionnaireAnswerDto,
} from '../../../api/@types'
import { UserRole } from '@/types/user'
import moment from 'moment'
import { Methods } from '../../../api/questionnaire-answer'

export type QuestionnaireActioons = ActionTree<
  QuestionnaireAnswerState,
  RootState
>

export const actions: QuestionnaireActioons = {
  async getQuestionnaireAnswers(
    { commit },
    params: Methods['get']['query'],
  ): Promise<void> {
    commit('setIsQuestionnaireAnswerLoading', true)
    const questionnaireAnswers = await fetchQuestionnaireAnswers(params)
    commit('questionnaireAnswerLoaded', questionnaireAnswers)
    commit('setIsQuestionnaireAnswerLoading', false)
  },
  async getQuestionnaireAnswer(
    { commit },
    id: number,
  ): Promise<QuestionnaireAnswerEntity> {
    commit('setIsQuestionnaireAnswerLoading', true)
    const questionnaire = await fetchQuestionnaireAnswer(id)
    commit('setQuestionnaireAnswer', questionnaire)
    commit('setIsQuestionnaireAnswerLoading', false)
    return questionnaire
  },
  async getReceipt({ commit }, id: number): Promise<void> {
    try {
      const receipt = await getReceipt(id)
      commit('setQuestionnaireAnswerReceipt', receipt)
    } catch (_) {
      console.error('Receipt not found.')
    }
  },
  async updateCheckStatus(
    { state },
    {
      questionnaireAnswer,
      userRole,
    }: { questionnaireAnswer: QuestionnaireAnswerEntity; userRole?: UserRole },
  ) {
    const dto: UpdateQuestionnaireAnswerDto = {
      id: state.questionnaireAnswer.id,
      defectReason: questionnaireAnswer.defectReason,
      messageToAdmin: questionnaireAnswer.messageToAdmin,
    }
    const status = questionnaireAnswer.ngReason === null ? 'ok' : 'ng'
    const checkedAt = moment().toISOString()
    if (questionnaireAnswer.ngReason === null) {
      dto.checkerCheckStatus = status
      dto.adminCheckStatus = status
      dto.checkerCheckedAt = checkedAt
      dto.adminCheckedAt = checkedAt
    } else {
      dto.ngReason = questionnaireAnswer.ngReason
      if (userRole === UserRole.ADMIN) {
        dto.adminCheckStatus = status
        dto.adminCheckedAt = checkedAt
      } else {
        dto.checkerCheckStatus = status
        dto.checkerCheckedAt = checkedAt
      }
    }
    await updateQuestionnaireAnswer(state.questionnaireAnswer.id, dto)
  },
  async updateQuestionAnswer(
    _ctx,
    textAnswers: (AnswerSummary & { source: string })[],
  ) {
    for (let ti = 0; ti < textAnswers.length; ti++) {
      const questionAnswer = textAnswers[ti]
      if (questionAnswer.type === QuestionType.TEXT) {
        await updateQuestionAnswer(questionAnswer.questionAnswerId, {
          text: questionAnswer.answerText,
          textArea: null,
        })
      } else if (questionAnswer.type === QuestionType.TEXT_AREA) {
        await updateQuestionAnswer(questionAnswer.questionAnswerId, {
          text: null,
          textArea: questionAnswer.answerText,
        })
      }
    }
  },
}
